var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-star",
    clipPath: "url(#clip0_1003_1690)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0C24.8375 0 32 7.1625 32 16ZM15.1062 7.05625L12.8375 11.65L7.775 12.3813C7.39375 12.4375 7.08125 12.7 6.9625 13.0625C6.85 13.425 6.94375 13.825 7.21875 14.0875L10.8813 17.6625L10.0188 22.7062C9.95625 23.0812 10.1062 23.4625 10.4187 23.6313C10.725 23.9125 11.1313 23.9375 11.4688 23.7625L15.9438 21.3813L20.5312 23.7625C20.8687 23.9375 21.275 23.9125 21.5812 23.6313C21.8937 23.4625 22.0438 23.0812 21.9813 22.7062L21.1187 17.6625L24.7812 14.0875C25.0562 13.825 25.15 13.425 25.0375 13.0625C24.9188 12.7 24.6063 12.4375 24.225 12.3813L19.1625 11.65L16.8937 7.05625C16.7312 6.71875 16.3813 6.5 15.9438 6.5C15.6188 6.5 15.2688 6.71875 15.1062 7.05625Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.40b21466768dfb73ef4c9d31695c378f.svg";
export { ForwardRef as ReactComponent };